import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.v5x_1 = call;
        this.w5x_1 = data.s5l_1;
        this.x5x_1 = data.r5l_1;
        this.y5x_1 = data.u5l_1;
        this.z5x_1 = data.t5l_1;
        this.a5y_1 = data.w5l_1;
      }
      e5j() {
        return this.v5x_1;
      }
      sv() {
        return this.e5j().sv();
      }
      f5j() {
        return this.w5x_1;
      }
      g5j() {
        return this.x5x_1;
      }
      e2o() {
        return this.y5x_1;
      }
      w50() {
        return this.z5x_1;
      }
      y5i() {
        return this.a5y_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
